export const formatPhone = (number) => {
  return number && number.length === 14 ? number.slice(3) : number
}

export const isInvalidPhone = phone => !phone || phone.replace(/\D/g, '').trim().length < 10
